/**
 * WithdrawContainer
 * --
 */
import React, { useState } from 'react';
import WithdrawPresenter from './WithdrawPresenter';
import { useUserAction, useUserStack } from 'store';
import { useDeleteUser } from 'hooks/UserHooks';
import MessageAlert, { deleteCookie } from 'utils';

const WithdrawContainer = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { navigate, screenSize } = props;

  /* ===== MUTATE ===== */
  const { deleteUser } = useDeleteUser();

  /* ===== STATE ===== */
  const [isChecked, setIsChecked] = useState(false);

  /* ===== VARIABLE ===== */
  // 유저 스토어정보
  const userInfo = useUserStack();
  const userAction = useUserAction();

  /* ===== FUNCTION ===== */
  const handleSubmit = async () => {
    // NOTE: 로그인이 안되어있을경우
    if (!userInfo) {
      window.alert('로그인 후 이용해주세요!');
      navigate('/signin', { state: { from: '/withdraw' } });
      return;
    }

    const confirm = window.confirm('정말 JM 회원 탈퇴를 하시겠습니까?');

    if (!confirm) return;

    try {
      const { status } = await deleteUser(userInfo?.user_id);

      if (status !== 200) {
        MessageAlert.warning(
          '회원 탈퇴에 실패하였습니다. 관리자에게 문의해주세요!'
        );
        return;
      }

      // 유저 store 리셋
      userAction.resetUser();
      // 토큰 삭제
      deleteCookie('JM_COFFEE_ACCESS_TOKEN', {});

      window.alert(
        '회원 탈퇴가 완료되었습니다.\n 그동안 서비스를 이용해 주셔서 감사합니다.'
      );
      navigate('/main');
    } catch (err) {
      MessageAlert.error(
        '회원 탈퇴에 실패하였습니다. 관리자에게 문의해주세요!'
      );
      console.error('[Withdraw handleSubmit] Error!!', err);
      throw err;
    }
  };
  /* ===== HOOKS ===== */

  /* ===== RENDER ===== */
  return (
    <>
      <WithdrawPresenter
        screenSize={screenSize}
        isChecked={isChecked}
        onToggle={setIsChecked}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default WithdrawContainer;
